import { Box, Chip } from "@mui/material";
import React from "react";
import { getStatusColor } from "utils/getStatusColor";
import { enterpriseTokens } from "styles/theme";

const StatusBadge = ({ status }) => {
    const { bgColor, textColor } = getStatusColor(status);

    return (
        <Chip
            sx={{
                height: "20px",
                borderRadius: "999px",
                backgroundColor: bgColor,
                padding: "2px 6px",
                fontFamily: "Inter, Outfit, sans-serif",
                fontWeight: 700,
                fontSize: "12px",
                border: `1px solid ${enterpriseTokens.lineSoft}`,
            }}
            label={
                <Box sx={{ color: textColor, fontWeight: 600, fontSize: "10px" }}>
                    {status}
                </Box>
            }
        />
    );
};

export default StatusBadge;
